import { useState } from 'react';

import { useQuery } from 'hooks/useQuery/useQuery';
import { QueryKeyEnum } from 'core/global.enum';
import {
  QueryKeyLocalStorageEnum,
  UsersLoginHistoryQueryKeysEnum,
  WantedHistoryQueryKeysEnum,
} from 'context/query/queryContext/QueryContext.enum';
import { useLocaleStoreQuery } from 'hooks/useLocaleStoreQuery/useLocaleStoreQuery';
import { useSavedPagination } from 'hooks/useSavedPagination/useSavedPagination';
import { fetchUsersLoginHistory } from 'api/users/users';

import { UsersLoginHistory } from './UsersLoginHistory';

export const UsersLoginHistoryContainer = () => {
  const {
    storedQueries: { usersLoginHistory: usersLoginHistoryQuery },
    setQuery,
  } = useLocaleStoreQuery();

  const [userSearchQuery, setUserSearchQuery] = useState(usersLoginHistoryQuery?.query?.label || '');

  const { page, rowsPerPage, setPage, setRowsPerPage, setPaginationCount, storedQueryWithoutPagination } =
    useSavedPagination({
      queryKey: QueryKeyLocalStorageEnum.USERS_LOGIN_HISTORY,
      resetPaginationDependencyArray: [userSearchQuery],
    });

  const { data: historyResponse, isLoading } = useQuery(
    [QueryKeyEnum.USERS_LOGIN_HISTORY, storedQueryWithoutPagination, rowsPerPage, page, userSearchQuery],
    () => fetchUsersLoginHistory(),
    {
      args: {
        ...storedQueryWithoutPagination,
        [UsersLoginHistoryQueryKeysEnum.QUERY]: usersLoginHistoryQuery.query?.value,
        [WantedHistoryQueryKeysEnum.LIMIT]: rowsPerPage,
        [WantedHistoryQueryKeysEnum.OFFSET]: rowsPerPage * page,
      },
      onSuccess: (response) => {
        setPaginationCount(response.count);
      },
    },
  );

  const onClearHistoryQuery = () => {
    setQuery(QueryKeyLocalStorageEnum.USERS_LOGIN_HISTORY, {
      page,
      rowsPerPage,
    });
    setUserSearchQuery('');
  };

  return (
    <UsersLoginHistory
      historyResponse={historyResponse}
      isLoading={isLoading}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
      userSearchQuery={userSearchQuery}
      setUserSearchQuery={setUserSearchQuery}
      onClearHistoryQuery={onClearHistoryQuery}
    />
  );
};
